import type { AlertProps } from "@p0security/ui";
import { Alert, Spacing } from "@p0security/ui";

import { join } from "../utils/join";

export const ErrorDisplay: React.FC<{
  title?: string;
  error: any;
  onClose?: () => void;
  type?: AlertProps["type"];
}> = ({ title, error, onClose, type = "error" }) => (
  <Spacing mb="1em">
    <Alert
      closable={!!onClose}
      description={join(String(error).split("\n"), (ix) => (
        <br key={ix} />
      ))}
      message={title}
      onClose={onClose}
      showIcon
      type={type}
    />
  </Spacing>
);
